import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
  VENDOR_TYPE_REQUEST,
  VENDOR_TYPE_CREATE,
  VENDOR_TYPE_DELETE,
  VENDOR_TYPE_EDIT,
  VENDOR_TYPE_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const VendorType = ({
  auth: { auth, isAuthenticated },
  valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
  fetchVendorType,
  submitVendorTypeCreate,
  submitVendorTypeDelete,
  submitVendorTypeEdit,
  changeReducerState
}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [deleteVendorTypeId, setDeleteVendorTypeId] = useState('');
  const [editVendorTypeId, setEditVendorTypeId] = useState('');
  const [editVendorType, setEditVendorType] = useState('');

  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchVendorType(auth[0].token);
    }
  }, [auth, isAuthenticated]);

  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("VendorType Created Successfully.");
      fetchVendorType(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("VendorType Deleted Successfully.");
      fetchVendorType(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("VendorType Data Updated Successfully.");
      fetchVendorType(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
  };

  // function called for input value change of create modal
  const handleCreateModalChange = (e) => {
    setInputVal(e.target.value);
  }

  // function called for create age demographic create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (inputVal === '') {
      toast.error("VendorType name cannot be empty.");
    } else {
      submitVendorTypeCreate({
        "data": {
          "VendorType": inputVal,
          "CreatedBy": auth[0].userId
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeleteVendorTypeId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteVendorTypeId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete age demographic delete api
  const handleConfirmDeleteSubmit = () => {
    submitVendorTypeDelete({
      "VendorTypeId": deleteVendorTypeId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setEditVendorTypeId(data.vendorTypeId);
    setEditVendorType(data.vendorType);
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (editVendorType === '') {
      toast.error("VendorType name cannot be empty.");
    } else {
      submitVendorTypeEdit({
        "data": {
          "VendorTypeId": data.vendorTypeId,
          "VendorType": editVendorType,
        },
        "token": auth[0].token
      });
      setEditVendorTypeId('');
      setEditVendorType('');
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">

          <div className="sub-header mt-5 mb-3">
            <h2>VendorType</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`VendorType`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              inputVal={inputVal}
              handleCreateModalChange={handleCreateModalChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>VendorType</th>
                <th width="50">Delete</th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (
                  <tr key={index}>
                    {editVendorTypeId === item.vendorTypeId ? (
                      <td>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control type="text" value={editVendorType} onChange={(evt) => setEditVendorType(evt.target.value)} />
                            <Button variant="outline-secondary">
                              <Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
                            </Button>
                          </InputGroup>
                        </Form.Group>
                      </td>
                    ) : (
                      <td>
                        {item.vendorType}
                        <Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                      </td>
                    )}
                    <td>
                      <ConfirmDelete variant="primary" title={`VendorType`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.vendorTypeId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
    </MainWrapper>
  );
}

const mapStateToProps = ({ auth, valueList }) => {
  return {
    auth,
    valueList
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchVendorType: (token) => dispatch({ type: VENDOR_TYPE_REQUEST, token }),
    submitVendorTypeCreate: (data) => dispatch({ type: VENDOR_TYPE_CREATE, payload: data }),
    submitVendorTypeDelete: (data) => dispatch({ type: VENDOR_TYPE_DELETE, payload: data }),
    submitVendorTypeEdit: (data) => dispatch({ type: VENDOR_TYPE_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: VENDOR_TYPE_STATE_CHANGE })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(VendorType);